import styles from "./index.module.scss";

export default function Auto({ auto }) {
  return (
    <div className={styles.Auto}>
      <img src={auto.PHOTO} />
      <div>
        <span>
          {auto.MARK.NAME} {auto.MODEL.NAME}
        </span>
        <span>{auto.NAME}</span>
      </div>
    </div>
  );
}
